import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';


@Component({
    selector: 'eas-editor-booking-item-name-form',
    templateUrl: './editor-booking-item-name-form.component.html',
    styleUrls: ['./editor-booking-item-name-form.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemNameFormComponent implements OnInit {
  @Input() parentFormGroup: FormGroup;
  @Input() itemNameForm: FormControl;

  constructor() {

  }

  ngOnInit() {

  }
}
